import * as React from 'react';
import { useMemo } from 'react';
import { BaggageList } from '../../../BaggageList';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import { convertBaggageOnBaggageItem } from '../../utils';
import { SelectedBaggageItem } from '../../../../BaggageService/types';
import { Segment } from '../../../types';
import { CdnIcon } from '@shared/ui';

interface Props {
	className?: string;
	segments: Segment[];
	includedBaggage: SelectedBaggageItem[][];
	sliderToShow?: number;
}

const Included: React.FC<Props> = ({ className, segments, includedBaggage, sliderToShow }) => {
	const { IncludedBaggage: css } = useTheme('IncludedBaggage');
	const { t } = useTranslation('IncludedBaggage');

	const items = useMemo(() => {
		return includedBaggage.map(baggage => convertBaggageOnBaggageItem(baggage, segments));
	}, [includedBaggage, segments]);

	return (
		<div className={className}>
			<div className={css.header}>
				<h2>
					<CdnIcon icon="Info/Item Icluded" />

					{t('Included')}
				</h2>

				{/*<div className={css.fare_family}>with Ecomomy Medium</div>*/}
			</div>
			<div className={css.body}>
				<BaggageList items={items} slidesToShow={sliderToShow} />
			</div>
		</div>
	);
};

export default Included;
